import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, deleteRole } from 'store/data/roles';

type HandlerInput = Parameters<typeof deleteRole>;

export function useDeleteRole(): Operation<(...input: HandlerInput) => void> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(ActionTypes.DELETE_ROLE);

	function handler(...input: HandlerInput) {
		if (loading) return;
		if (error) resetError();

		dispatch(deleteRole(...input));
	}

	return [{ loading, error }, handler];
}
